import { ScrollTrackingBlockData } from 'api/cms';
import { BlockMapping } from 'cms/blocks/BlockMapping';

import { ScrollTrackingBlock } from './ScrollTrackingBlock';

export const ScrollTrackingBlockMapping: BlockMapping<ScrollTrackingBlockData> =
  {
    invariant: [],
    width: 'FULL',
    Component: ScrollTrackingBlock,

    AmpComponent: ScrollTrackingBlock,
  };
